<nh-form [formGroup]="getForm()" [mode]="mode" (validate)="onValidate($event)">
    <section class="summary-left">
        <div>
            <h1 class="section-header">{{MEDICAL_APPEAL_SUMMARY_STATIC1 | globalTranslate}}</h1>
            <hr>
        </div>
        <p [innerHTML]="MEDICAL_APPEAL_SUMMARY_STATIC2 | globalTranslate"></p>
        <div id="accordion">

            <!-- Medical Appeal Request Information Table -->
            <div id="heading_1">
                <div class="row">
                    <div class="col-12 d-flex align-items-center justify-content">
                        <div id="caratId_1" class="carat d-none d-lg-block" tabindex="0" role="button"
                            (keydown.enter)="logInfo($event)" (keydown.space)="logInfo($event)"><span id="dwn_1"
                                class="cla2"><i class="fa fa-2x fa-angle-down"
                                    [attr.aria-label]="('Expand' | globalTranslate) + ' ' + MEDICAL_APPEAL_SUMMARY_STATIC3 | globalTranslate"></i></span><span
                                id="up_1" class="cla1"><i class="fa fa-2x fa-angle-up"
                                    [attr.aria-label]="('Collapse' | globalTranslate) + ' ' + MEDICAL_APPEAL_SUMMARY_STATIC3 | globalTranslate"></i></span>
                        </div>
                        <h2 id="headerButton_1" class="section-header ps-3" tabindex="0">
                            {{MEDICAL_APPEAL_SUMMARY_STATIC3 | globalTranslate}}</h2>
                        <div id="caratId_1" class="carat d-lg-none" tabindex="0" role="button"
                            (keydown.enter)="logInfo($event)" (keydown.space)="logInfo($event)"><span id="dwn_1"
                                class="cla2"><i class="fa fa-2x fa-angle-down"
                                    [attr.aria-label]="('Expand' | globalTranslate) + ' ' + MEDICAL_APPEAL_SUMMARY_STATIC3 | globalTranslate"></i></span><span
                                id="up_1" class="cla1"><i class="fa fa-2x fa-angle-up"
                                    [attr.aria-label]="('Collapse' | globalTranslate) + ' ' + MEDICAL_APPEAL_SUMMARY_STATIC3 | globalTranslate"></i></span>
                        </div>
                    </div>
                </div>
                <hr>
            </div>
            <div id="collapse_1" class="collapse" aria-labelledby="heading_1" data-bs-parent="#accordion">
                <div class="card-body d-none d-lg-block">
                    <p> {{MEDICAL_APPEAL_SUMMARY_STATIC4 | globalTranslate}}</p>
                    @if (mainInfoArray?.length) {
                    <table class="table table-bordered">
                        <tbody class="thead-light text-start">
                            @for (item of mainInfoArray; track item; let i = $index) {
                            <tr>
                                <th scope="row">{{item.key | globalTranslate}}</th>
                                @if (translatedLang !== 'sp') {
                                <td>{{ requestInfoNoTranslateArray.includes(item.key) ? item.value : (item.value | globalTranslate) }}</td>
                                } @else {
                                <td>{{(item?.spValue ? item.spValue : item.value) | globalTranslate}}</td>
                                }
                            </tr>
                            }
                        </tbody>
                    </table>
                    }
                    @if (filerContactArray?.length) {
                        <h3 class="section-header filer_header mt-3">{{'FILER_CONTACT_INFO_HEADER' | globalTranslate}}</h3>
                        <table class="table table-bordered">
                            <tbody class="thead-light text-start">
                                @for (item of filerContactArray; track item) {
                                <tr>
                                    <th scope="row">{{item.key | globalTranslate}}</th>
                                    @if (translatedLang !== 'sp') {
                                    <td>{{ requestInfoNoTranslateArray.includes(item.key) ? item.value : (item.value | globalTranslate) }}</td>
                                    } @else {
                                    <td>{{(item?.spValue ? item.spValue : item.value) | globalTranslate}}</td>
                                    }
                                </tr>
                                }
                            </tbody>
                        </table>
                    }
                </div>
                <div class="card-body nh-table-mobile d-lg-none">
                    <p> {{MEDICAL_APPEAL_SUMMARY_STATIC4 | globalTranslate}}</p>
                    @for (item of mainInfoArray; track item; let i = $index) {
                    <div class="table-row mb-3 pb-3">
                        <div class="mobile-table-header">{{item.key | globalTranslate}}</div>
                        <hr>
                        @if (translatedLang !== 'sp') {
                        <div class="mobile-table-data">{{ requestInfoNoTranslateArray.includes(item.key) ? item.value : (item.value | globalTranslate) }}</div>
                        } @else {
                        <div class="mobile-table-data">{{(item?.spValue ? item.spValue : item.value) | globalTranslate}}</div>
                        }
                    </div>
                    }
                    @if (filerContactArray?.length) {
                        <h3 class="section-header filer_header mt-3">{{'FILER_CONTACT_INFO_HEADER' | globalTranslate}}</h3>
                        <hr>
                        @for (item of filerContactArray; track item) {
                        <div class="table-row mb-3 pb-3">
                            <div class="mobile-table-header">{{item.key | globalTranslate}}</div>
                            <hr>
                            @if (translatedLang !== 'sp') {
                            <div class="mobile-table-data">{{ requestInfoNoTranslateArray.includes(item.key) ? item.value : (item.value | globalTranslate) }}</div>
                            } @else {
                            <div class="mobile-table-data">{{(item?.spValue ? item.spValue : item.value) | globalTranslate}}</div>
                            }
                        </div>
                        }
                    }
                </div>
            </div>

            <!-- Medical Appeal Request Details Table -->
            <div id="heading_2">
                <div class="row">
                    <div class="col-12 d-flex align-items-center justify-content">
                        <div id="caratId_2" class="carat d-none d-lg-block" tabindex="0" role="button"
                            (keydown.enter)="logInfo($event)" (keydown.space)="logInfo($event)"><span id="dwn_2"
                                class="cla2"><i class="fa fa-2x fa-angle-down"
                                    [attr.aria-label]="('Expand' | globalTranslate) + ' ' + MEDICAL_APPEAL_SUMMARY_STATIC5 | globalTranslate"></i></span><span
                                id="up_2" class="cla1"><i class="fa fa-2x fa-angle-up"
                                    [attr.aria-label]="('Collapse' | globalTranslate) + ' ' + MEDICAL_APPEAL_SUMMARY_STATIC5 | globalTranslate"></i></span>
                        </div>
                        <h2 id="headerButton_2" class="section-header ps-3" tabindex="0">
                            {{MEDICAL_APPEAL_SUMMARY_STATIC5 | globalTranslate}}</h2>
                        <div id="caratId_2" class="carat d-lg-none" tabindex="0" role="button"
                            (keydown.enter)="logInfo($event)" (keydown.space)="logInfo($event)"><span id="dwn_2"
                                class="cla2"><i class="fa fa-2x fa-angle-down"
                                    [attr.aria-label]="('Expand' | globalTranslate) + ' ' + MEDICAL_APPEAL_SUMMARY_STATIC5 | globalTranslate"></i></span><span
                                id="up_2" class="cla1"><i class="fa fa-2x fa-angle-up"
                                    [attr.aria-label]="('Collapse' | globalTranslate) + ' ' + MEDICAL_APPEAL_SUMMARY_STATIC5 | globalTranslate"></i></span>
                        </div>
                    </div>
                </div>
                <hr>
            </div>

            <div id="collapse_2" class="collapse" aria-labelledby="heading_2" data-bs-parent="#accordion">
                <div class="card-body d-none d-lg-block">
                    <p> {{MEDICAL_APPEAL_SUMMARY_STATIC6 | globalTranslate}}</p>
                    @if (medicalAppealDetailsArray?.length) {
                    <table class="table table-bordered">
                        <tbody class="thead-light text-start">
                            @for (item of medicalAppealDetailsArray; track item; let i = $index) {
                            <tr>
                                <!-- <th *ngIf="i !== this.editKey && !item.coverageKey" scope="col">{{item.key |
                                    globalTranslate}}</th>
                                <th *ngIf="i === this.editKey && !item.coverageKey" scope="col">{{ array[0] |
                                    globalTranslate}}{{array2[0] |globalTranslate}}{{array2[1] | globalTranslate}}</th>
                                <th *ngIf="item.coverageKey" scope="col">{{ item.coverageKey |
                                    globalTranslate}}{{item.name | globalTranslate}}</th>
                                <td>{{item.value | globalTranslate}}</td> -->
                                 <th scope="row">{{item.key | globalTranslate}}</th>
                                 @if (translatedLang !== 'sp') {
                                 <td>{{item.value | globalTranslate}}</td>
                                 } @else {
                                 <td>{{(item?.spValue ? item.spValue : item.value) | globalTranslate}}</td>
                                 }
                            </tr>
                            }
                        </tbody>
                    </table>
                    }
                </div>

                <div class="nh-table-mobile d-lg-none">
                    <p> {{MEDICAL_APPEAL_SUMMARY_STATIC6 | globalTranslate}}</p>
                    @for (item of medicalAppealDetailsArray; track item; let i = $index) {
                    <div class="table-row mb-3 pb-3">
                        <div class="mobile-table-header">{{item.key | globalTranslate}}</div>
                        <hr>
                        @if (translatedLang !== 'sp') {
                        <div class="mobile-table-data">{{item.value | globalTranslate}}</div>
                        } @else {
                        <div class="mobile-table-data">{{(item?.spValue ? item.spValue : item.value) | globalTranslate}}</div>
                        }
                    </div>
                    }
                </div>
            </div>

            <!-- Member Demographics Table -->
            <div id="heading_3">
                <div class="row">
                    <div class="col-12 d-flex align-items-center justify-content">
                        <div id="caratId_3" class="carat d-none d-lg-block" tabindex="0" role="button"
                            (keydown.enter)="logInfo($event)" (keydown.space)="logInfo($event)"><span id="dwn_3"
                                class="cla2"><i class="fa fa-2x fa-angle-down"
                                    [attr.aria-label]="('Expand' | globalTranslate) + ' ' + MEDICAL_APPEAL_SUMMARY_STATIC7 | globalTranslate"></i></span><span
                                id="up_3" class="cla1"><i class="fa fa-2x fa-angle-up"
                                    [attr.aria-label]="('Collapse' | globalTranslate) + ' ' + MEDICAL_APPEAL_SUMMARY_STATIC7 | globalTranslate"></i></span>
                        </div>
                        <h2 id="headerButton_3" class="section-header ps-3" tabindex="0">
                            {{MEDICAL_APPEAL_SUMMARY_STATIC7 | globalTranslate}}</h2>
                        <div id="caratId_3" class="carat  d-lg-none" tabindex="0" role="button"
                            (keydown.enter)="logInfo($event)" (keydown.space)="logInfo($event)"><span id="dwn_3"
                                class="cla2"><i class="fa fa-2x fa-angle-down"
                                    [attr.aria-label]="('Expand' | globalTranslate) + ' ' + MEDICAL_APPEAL_SUMMARY_STATIC7 | globalTranslate"></i></span><span
                                id="up_3" class="cla1"><i class="fa fa-2x fa-angle-up"
                                    [attr.aria-label]="('Collapse' | globalTranslate) + ' ' + MEDICAL_APPEAL_SUMMARY_STATIC7 | globalTranslate"></i></span>
                        </div>
                    </div>
                </div>
                <hr>
            </div>
            <div id="collapse_3" class="collapse" aria-labelledby="heading_3" data-bs-parent="#accordion">
                <div class="card-body d-none d-lg-block">
                    <p> {{MEDICAL_APPEAL_SUMMARY_STATIC8 | globalTranslate}}</p>
                    @if (medicalAppealDemographicsArray?.length) {
                    <table class="table table-bordered">
                        <tbody class="thead-light text-start">
                            @for (item of medicalAppealDemographicsArray; track item; let i = $index) {
                            <tr>
                                <th scope="row">{{item.key | globalTranslate}}</th>
                                <td>{{((item.key === 'Spoken Language' || item.key === 'Written Language') && translatedLang === 'sp' ? ((item?.spValue
                                    ? item.spValue : item.value) | globalTranslate) : ((demographicsNoTranslateArray.includes(item.key) && item.value
                                    !== 'Not Answered') ? item.value : item.value | globalTranslate))}}</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                    }
                </div>
                <div class="nh-table-mobile d-lg-none">
                    <p> {{MEDICAL_APPEAL_SUMMARY_STATIC8 | globalTranslate}}</p>
                    @for (item of medicalAppealDemographicsArray; track item; let i = $index) {
                    <div class="table-row mb-3 pb-3">
                        <div class="mobile-table-header">{{item.key | globalTranslate}}</div>
                        <hr>
                        <div class="mobile-table-data text-wrap">{{((item.key === 'Spoken Language' || item.key === 'Written Language') &&
                            translatedLang === 'sp' ? ((item?.spValue ? item.spValue : item.value) | globalTranslate) :
                            ((demographicsNoTranslateArray.includes(item.key) && item.value !== 'Not Answered') ? item.value : item.value |
                            globalTranslate))}}
                        </div>
                    </div>
                    }
                </div>
            </div>
            
        </div>
    </section>
</nh-form>